export default __webpack_public_path__ + "static/media/480_dummy2016-streetfashion01-mobile-de.c7f2fb54.png";